import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';
import { Add as AddIcon }from '@mui/icons-material';

import SubmitBtn from 'src/shared/buttons/SubmitBtn';
import styles from './style';

interface PropTypes {
  loading: boolean;
  handleAddNewOpen: () => void;
}

const WorkflowsEmptyContainer = (props: PropTypes) => {
  const { t } = useTranslation();

  const { loading, handleAddNewOpen } = props;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.titleContainer}>
        <Typography style={styles.title}>{t('WORKFLOWS_EMPTY_TITLE')}</Typography>
        <Typography style={styles.subtitle}>{t('WORKFLOWS_EMPTY_SUBTITLE')}</Typography>
      </Box>
      <SubmitBtn
        title={t('WORKFLOWS_CREATE_PROJECT')}
        onClick={handleAddNewOpen}
        disabled={loading}
        startIcon={<AddIcon sx={styles.addIcon} />}
      />
    </Box>
  );
}

export default WorkflowsEmptyContainer;
